<template>
  <a href="#" class="dropdown-item" @click.prevent="onClick">
    <slot />
  </a>
</template>

<script>
export default {
  name: 'BDropdownItem',
  emits: ['click'],
  inject: {
    closeBDropdown: { default: null }
  },
  methods: {
    onClick (event) {
      this.$emit('click', event)
      this.closeBDropdown?.()
    }
  }
}
</script>
